import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationStart, Route, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { isTemplateMiddle } from 'typescript';
@Component({
  selector: 'app-report-skills',
  templateUrl: './report-skills.component.html',
  styleUrls: ['./report-skills.component.scss']
})
export class ReportSkillsComponent implements OnInit {

  constructor(
    private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService,
    private router: Router, private filterDataHandlerService: FilterDataHandlerService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private hashService: HashService
  , private talentInsightsService: TalentInsightsService) { }
  skills: any;
  skillsData: any = [];
  displayedColumns: string[] = ['key', 'doc_count', 'graph'];
  @ViewChild('skillsTbSort') skillsTbSort: MatSort;
  totalResultCount: number = 0;
  startindex: number = 0;
  aggregatescount: number = 50;
  topFiveSkills: any = [];
  apiCalled: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;
  start: number = 0;
  end: number = 10;
  totalCount: number = 0;
  talentfilterdata: any = {};
  subscriptions: Array<Subscription> = [];
  /**Sorted data of skill from pages shown */
  skillsSortData:any;
  skillsdataAI: any

  insightsExportSubscription: Subscription = null;

  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  ngOnInit(): void {
    // const skillssubscription = this.personSearchService.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(skillssubscription);

    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData 
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.getSkills();
    this.personSearchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  getSkills() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "skills";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.apiCalled = true;
      this.totalResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.skills;
      this.totalCount = tempData.length;
      this.skillsSortData = tempData;
      this.skillsData = tempData.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      this.skills.sort = this.skillsTbSort;
      this.topFiveSkills = tempData.slice(0, 5);
      this.manualSort();
      this.getskillsdataai(this.skillsSortData);
    });
  }

  getSkillPercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  manualSort() {
    this.reSortArr(this.skillsTbSort);
  }
  
  reSortArr(sort){
    const tempData = this.skillsSortData;

    if(!sort || !sort.active || sort.direction === ''){
      this.skillsData = tempData.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      this.skills.sort = this.skillsTbSort;
      return;
    }
    this.skillsSortData = tempData.sort((a,b)=>{
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
        default: return 0;
      }
    })
    
    this.skillsData = this.skillsSortData.slice(this.start, this.end);
    this.skills = new MatTableDataSource(this.skillsData);
    this.skills.sort = this.skillsTbSort;
  }

  compare(a:number, b:number, isAsc:boolean){
    return(a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getSkills();
    }
    else{
      this.manualSort();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

   /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
   handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;

    const additionalFilters = {};
    switch(type) {
      case 'skills': additionalFilters['mandatoryskills'] = [key]; break;
    }

    this.talentfilterdata['additionalFilters'] = additionalFilters;
    // this.localstorageservice.setItem('talentfilters', JSON.stringify(this.talentfilterdata));
    // this.personSearchService.setTalentinsights(this.talentfilterdata);
    // this.router.navigate(['/person/search/listing'], { queryParams: { 'redirectSource': 'talent-insights' } })
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  getskillsdataai(data) {
    let skillsdata: any;
    skillsdata = data.map(x=>{
      let res: any ={};
      res['Top Skills'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['% of Total'] = this.getSkillPercentage(x.doc_count)+'%';
      return res;
    
    })
    this.skillsdataAI = {
      skills: skillsdata
    }
    if(this.skillsData.length == 0)
      this.skillsdataAI = null;
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== 'skills') return;

    const payloadForInsightsExport = {
      tab: 'skills',
      totalresultcount: this.totalResultCount,
      skills: this.skillsSortData
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
